<div class="col-12 col-sm-12 container-hours" style="margin-top: 20px; padding: 5px;">
  <div class="row row-cols-1 row-cols-sm-2 p-sm-0 m-sm-0 align-items-stretch" style="gap:10px;">

    <div class="col-12 col-sm p-0 container-calendar d-flex">
      <app-calendar-month
        (messageEvent)="clickDayCalendar($event)"
        (messageMonth)="clickMonthCalendar($event)">
      </app-calendar-month>
    </div>

    <div class="col-12 col-sm d-flex p-0">

      <div
        *ngIf="dia_seleccionado && horasCargadas"
        class="list-hours hours-card w-100"
        style="padding: 0 20px;">

        <div class="hours-header p-sm-3">
          <div class="row row-cols-sm-2 pt-3 pb-3">
            <div class="col-6 col-sm-6">
              <span class="available-hours-title">Horas disponibles</span>
            </div>

            <div class="col-6 col-sm-6 text-right">
              <span class="date">{{ daySelected.dayTitle }}</span>
            </div>
          </div>
        </div>

        <div class="hours-tabs-container px-sm-3 pb-sm-3">

          <div class="not-hours" *ngIf="daySelected?.available == false">
            <div class="d-flex">
              <mat-icon>info</mat-icon>
              <span>No existen horas disponibles para este día.</span>
            </div>
          </div>

          <mat-tab-group
            *ngIf="daySelected?.available"
            class="hours-tab-group"
            [(selectedIndex)]="selectedHourTabIndex">

            <mat-tab label="AM">
              <div class="hours-tab-scroll">

                <ng-container *ngIf="horasAgrupadasAM?.length > 0; else noHoursAM">

                  <ng-container *ngFor="let group of horasAgrupadasAM">

                    <ng-container *ngIf="group.hours?.length > 0">

                      <div class="hour-block-header mb-2">
                        <span class="hour-block-title">{{ group.block }}:00</span>
                        <div class="hour-block-line"></div>
                      </div>

<div class="row mb-2 mx-0 px-0">
                        <ng-container *ngFor="let itemHour of group.hours">

                          <div class="col-4 px-0 text-center" *ngIf="itemHour.existe">

                            <button
                              type="button"
                              (click)="clickHour(itemHour)"
                              [ngClass]="{
                                'btn hour-btn-habilitada': itemHour.available && !itemHour.is_ondemand,
                                'btn hour-btn-habilitada-od': itemHour.sta_id == 21 && itemHour.is_ondemand,
                                'btn hour-btn-bloqueada': !itemHour.available && !itemHour.is_ondemand,
                                'btn hour-btn-bloqueada-od': itemHour.sta_id == 22 && itemHour.is_ondemand
                              }"
                              style="width: 90%;">
                              {{ itemHour.from }}
                            </button>

                          </div>

                        </ng-container>

                      </div>

                    </ng-container>

                  </ng-container>

                </ng-container>

                <ng-template #noHoursAM>
                  <div class="not-hours" style="margin: 10px 0; text-align: center;">
                    <div class="d-flex">
                      <mat-icon>info</mat-icon>
                      <span>No existen horas AM disponibles para este día.</span>
                    </div>
                  </div>
                </ng-template>

              </div>
            </mat-tab>

            <mat-tab label="PM">
              <div class="hours-tab-scroll">

                <ng-container *ngIf="horasAgrupadasPM?.length > 0; else noHoursPM">

                  <ng-container *ngFor="let group of horasAgrupadasPM">

                    <ng-container *ngIf="group.hours?.length > 0">

                      <div class="hour-block-header mb-2">
                        <span class="hour-block-title">{{ group.block }}:00</span>
                        <div class="hour-block-line"></div>
                      </div>

<div class="row mb-2 mx-0 px-0">
                        <ng-container *ngFor="let itemHour of group.hours">

                          <div class="col-4 px-0 text-center" *ngIf="itemHour.existe">

                            <button
                              type="button"
                              (click)="clickHour(itemHour)"
                              [ngClass]="{
                                'btn hour-btn-habilitada': itemHour.available && !itemHour.is_ondemand,
                                'btn hour-btn-habilitada-od': itemHour.sta_id == 21 && itemHour.is_ondemand,
                                'btn hour-btn-bloqueada': !itemHour.available && !itemHour.is_ondemand,
                                'btn hour-btn-bloqueada-od': itemHour.sta_id == 22 && itemHour.is_ondemand
                              }"
                              style="width: 90%;">
                              {{ itemHour.from }}
                            </button>

                          </div>

                        </ng-container>

                      </div>

                    </ng-container>

                  </ng-container>

                </ng-container>

                <ng-template #noHoursPM>
                  <div class="not-hours" style="margin: 10px 0; text-align: center;">
                    <div class="d-flex">
                      <mat-icon>info</mat-icon>
                      <span>No existen horas PM disponibles para este día.</span>
                    </div>
                  </div>
                </ng-template>

              </div>
            </mat-tab>

          </mat-tab-group>

        </div>

      </div>
    </div>

  </div>
</div>